import { StatistikEnv } from '../../env/StatistikEnv';
import { StatistikPageStore } from '../statistik/StatistikPageStore';
import { Store } from './Store';

export class StatistikStore {
  readonly store: Store;

  constructor(store) {
    this.store = store;
    if (typeof window !== 'undefined') {
      (window as any).statistikStore = this;
    }
  }

  get statistikData() {
    return this.store.storeData.statistikData;
  }

  get statistikhash() {
    return this.statistikData.statistikhash;
  }

  get chartSecure() {
    return this.statistikData.chartSecure;
  }

  get displayName() {
    return this.statistikData.displayName;
  }

  get statistikUser() {
    return this.statistikData.statistikUser;
  }

  // @observable test = 1;
}
